// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__242BL","newExpiryDate":"styles_newExpiryDate__1fXrc","footer":"styles_footer__3wqb_"};